import React, { useMemo } from "react";
import { mask } from "remask";
import globalMU from "globalMU";
import { IItemOrcamento } from "app/types/IItemOrcamento";
const estiloDetalhesProduto = require("./detalhes-produto.module.scss").default;

export type DetalhesProdutoProps = {
  item: IItemOrcamento;
  exibirComissaoVenda: boolean;
  exibirQuantidadeMinimaDeVenda: boolean;
  exibirEstoques: boolean;
  mascara: string;
};

type CampoDetalheProduto = {
  id: string;
  rotulo: string;
  valor: React.ReactNode;
  estilo?: React.CSSProperties;
};

const formatarQuantidadeEstoque = (quantidadeEstoque) => {
  return quantidadeEstoque
    .toString()
    .replace(/(.{3})/g, "$1.")
    .replace(/\.$/, "")
    .concat(",000");
};

const DetalhesProdutoComponent = (props: DetalhesProdutoProps) => {
  const campos = useMemo<CampoDetalheProduto[]>(() => {
    const item = props.item;

    const lista: CampoDetalheProduto[] = [
      {
        id: "DetalhesProduto_Descricao",
        rotulo: "Descrição",
        estilo: { fontWeight: 700, backgroundColor: "var(--mu-superficie, #FFFFFF)" },
        valor: item?.Descricao?.toUpperCase(),
      },
      { id: "DetalhesProduto_Referencia", rotulo: "Referência", valor: item?.Referencia },
      { id: "DetalhesProduto_Codigo", rotulo: "Código", valor: item?.Codigo },
      { id: "DetalhesProduto_Unidade", rotulo: "Unidade", valor: item?.Unidade1 },
      { id: "DetalhesProduto_Modelo", rotulo: "Modelo", valor: item?.Modelo },
      {
        id: "DetalhesProduto_PrecoUnitario",
        rotulo: "Preço Unitário",
        valor: globalMU.formatarValorNumerico(item?.Preco, 2, true),
      },
      { id: "DetalhesProduto_CodigoFabricante", rotulo: "Código do Fabricante", valor: item?.CodigoFabricante },
      { id: "DetalhesProduto_Fornecedor", rotulo: "Fornecedor", valor: item?.NomeFornecedor },
      {
        id: "DetalhesProduto_SegundaUnidade",
        rotulo: "2ª Unidade",
        valor: item?.UnidadeProduto2 ? item?.UnidadeProduto2 : item?.Unidade2,
      },
      {
        id: "DetalhesProduto_Status",
        rotulo: "Status",
        valor: item?.StatusProduto ? item?.StatusProduto : item?.Status,
      },
      {
        id: "DetalhesProduto_Classe",
        rotulo: "Classe",
        valor: (
          <>
            <a className={estiloDetalhesProduto.codigoClasse}>
              {mask(item?.CodigoClasse ?? "", props.mascara ?? "", {
                placeholder: "_",
              })}
            </a>
            {` - ${item?.Classe}`}
          </>
        ),
      },
      { id: "DetalhesProduto_Disponibilidade", rotulo: "Disponibilidade", valor: item?.DescricaoDisponibilidade },
      { id: "DetalhesProduto_FatorConversao", rotulo: "Fator de Conversão", valor: item?.FatorConversao },
    ];

    if (props.exibirComissaoVenda) {
      lista.push({ id: "DetalhesProduto_ComissaoVenda", rotulo: "Comissão venda", valor: item?.ComissaoVenda });
    }

    if (props.exibirQuantidadeMinimaDeVenda) {
      lista.push({
        id: "DetalhesProduto_QtdeMinimaVenda",
        rotulo: "Qtde Mínima de Venda",
        valor: globalMU.formatarValorNumerico(item?.MenorFracaoVenda, 3, false),
      });
    }

    lista.push(
      { id: "DetalhesProduto_PrecoAVista", rotulo: "Preço à Vista", valor: item?.PrecoAVista },
      {
        id: "DetalhesProduto_TextoTecnico",
        rotulo: "Texto Técnico",
        estilo: { whiteSpace: "pre-wrap" },
        valor: item?.TextoTecnico,
      }
    );

    if (props.exibirEstoques) {
      lista.push(
        {
          id: "DetalhesProduto_EstoqueCD",
          rotulo: "Estoque CD",
          valor: formatarQuantidadeEstoque(item?.QuantidadeEstoqueCD),
        },
        {
          id: "DetalhesProduto_EstoqueOutrasFiliais",
          rotulo: "Estoque Outras Filiais",
          valor: formatarQuantidadeEstoque(item?.QuantidadeEstoqueOutraFilial),
        }
      );
    }

    return lista;
  }, [props.item, props.mascara, props.exibirComissaoVenda, props.exibirQuantidadeMinimaDeVenda, props.exibirEstoques]);

  return (
    <div className={estiloDetalhesProduto.gridContainerDetalheProduto}
      id="DetalhesProduto_Div"
    >
      {campos.map((campo) => (
        <React.Fragment key={campo.id}>
          <label>{campo.rotulo}</label>
          <div id={campo.id} style={campo.estilo}>{campo.valor}</div>
        </React.Fragment>
      ))}
      {<section style={{ marginBottom: "100px" }} />}
    </div>
  );
};

const DetalhesProduto = React.memo(DetalhesProdutoComponent);
DetalhesProduto.displayName = "DetalhesProduto";

export { DetalhesProduto };
